import { inject, InjectionToken } from '@angular/core';

import { DialogRef } from './dialog-ref';

export interface DialogComponentI<DialogData, _DialogResult> {
  // Called before ngOnInit lifecycle hook
  setDialogData: (data: DialogData, triggerUpdate: boolean) => void;
  webComponentOutput?: _DialogResult;
}

export const DialogData = new InjectionToken<any>('DialogData');

export const injectDialogData = () => inject(DialogData);

// if you don't want to pass any value to the dialog, you can use null, undefined, or void as the type
export abstract class DialogComponent<DialogData, DialogResult = any> {
  protected dialogData = <DialogData>inject(DialogData);
  protected dialogRef = <DialogRef<DialogComponent<DialogData>, DialogResult>>inject(DialogRef);
}
